import { useSelector } from 'react-redux';

 
import { getGovernanceEnvironment } from '../../redux/selectors';
import { GovernanceEnvironment } from '../../redux/slices';

export function useGovernanceEnvironment(): GovernanceEnvironment | undefined {
  return useSelector(getGovernanceEnvironment);
}
